/* aspectRatioUtils.ts */

import BmmpAsset from "app/lib/bmmr-asset-js/bmmp-asset";
import { DEFAULT_ASPECT_RATIO } from "app/utils/Constant";

export interface AspectRatio {
    width: number,
    height: number
}

export function parseAspectRatio(aspectRatio: string): AspectRatio {
    const k = aspectRatio.split(":").map(x => parseInt(x));
    return { width: k[0], height: k[1] } ?? { width: 16, height: 9 };
}

export interface UserOptions {
    respectAspectRatio?: boolean
    aspectRatio?: string
}

/*
    There are two types of aspectRatios.
    1. The player's aspect ratio ( Controlled by tag passed in to embedOptions from the HTML )
    2. The asset's aspect ratio ( Field fetched from BMMP response )
    This function uses respectAspectRatio to prioritize BMMP aspect ratio when set to true
 */
export function getAspectRatio(bmmpAsset: BmmpAsset, userOptions: UserOptions) {
    if (userOptions?.respectAspectRatio) {
        return bmmpAsset.getAspectRatio() || DEFAULT_ASPECT_RATIO;
    } else {
        return userOptions?.aspectRatio || DEFAULT_ASPECT_RATIO;
    }
}

export function isVerticalVideo(aspectRatio: string): boolean {
    const parsedAspectRatio: AspectRatio = parseAspectRatio(aspectRatio ?? "16:9");
    return parsedAspectRatio.width < parsedAspectRatio.height;
}
